module.exports = __webpack_public_path__ + "static/media/page-13.ba30cba2.png";